// eslint-disable-next-line import/prefer-default-export
export const loginDetailsSelector = (state) => state.app.loginDetails;
export const profileDetailsSelector = (state) => state.app.profileDetails;
export const profileChoosenSelector = (state) => state.app.profileChoosen;
export const profilePhotoSelector = (state) => state.app.profilePhoto;
export const accountListSelector = (state) => state.app.accountList;
export const depositAccountListSelector = (state) => state.app.depositList;
export const loanAccountListSelector = (state) => state.app.loanList;
export const loginVerifyDetailsSelector = (state) =>
  state.app.loginVerifyDetails;
export const txnPendingCountsSelector = (state) => state.app.txnPendingCounts;
export const menuOpenSelector = (state) => state.app.menuOpen;
export const accessListSelector = (state) => state.app.accessList;
export const modeSelector = (state) => state.app.mode;
export const serviceLoaderSelector = (state) => state.app.serviceLoader;
export const selectedAccountSelector = (state) => state.app.selectedAccount;
export const transactionCurrencyListSelector = (state) =>
  state.app.transactionCurrencyList;
export const currentAccountDetailsSelector = (state) =>
  state.app.currentAccountDetails;
export const defaultPathSelector = (state) => state.app.defaultPath;
export const quickLinksDataSelector = (state) =>
  state.app.quickLinksData;
export const getLanguageSelector = (state) => state.app.language;
export const sessionTimeoutSelector = (state) => state.app.sessionTimeOut;
export const otpTimerSelector = (state) => state.app.otpTimerDetails;
export const quickSearchSelector = (state) => state.app.quickSearch;
export const transferAccountListSelector = (state) => state.app.accountList;
export const countryCodesSelector = (state) => state.app.countryCodesList;

